import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';

import { RENTAL_MANAGER_API_V1_PREFIX } from '../../constants/RouteConstants';
import LeadCountsForListing from '../../model/LeadCountsForListing';
import makeRequest from '../../utils/makeRequestUtils';
import useRequestConfig from '../../hooks/useRequestConfig';
import { logError } from '@zg-rentals/log-error';

const useGetConversationCountsForListing = (listingAlias: string, queryOptions = {}) => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig();

  const queryFn = () =>
    makeRequest({
      dispatch,
      endpoint: `${RENTAL_MANAGER_API_V1_PREFIX}/users/listingConversation/getConversationCountsForListing`,
      requestConfig,
      config: { params: { listingAlias, calculateInRealTime: true } },
    });

  return useQuery({
    queryKey: ['getConversationCountsForListing', listingAlias],
    queryFn: async () => {
      try {
        const data = await queryFn();
        return LeadCountsForListing(data);
      } catch (error) {
        logError({
          error,
          context: 'Leads.getConversationCountsForListing',
        });
        throw error;
      }
    },
    ...queryOptions,
    enabled: Boolean(listingAlias),
    staleTime: 8 * 1000,
  });
};

const useInitiateCountsSync = (listingAlias: string, queryOptions = {}) => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig();

  const queryFn = () =>
    makeRequest({
      dispatch,
      endpoint: `${RENTAL_MANAGER_API_V1_PREFIX}/users/listingConversation/cachedConversationCounts`,
      requestConfig,
      config: {},
    }).catch((error) => {
      logError({
        error,
        context: 'Leads.initiateCountsSync',
      });
    });

  return useQuery({
    queryKey: ['initiateCountsSync', listingAlias],
    queryFn,
    ...queryOptions,
    staleTime: 8 * 1000,
  });
};

export { useGetConversationCountsForListing, useInitiateCountsSync };
